import { IconButton, makeStyles, Box } from '@material-ui/core'
import Clear from '@material-ui/icons/Clear'
import React from 'react'
import { REPRESENTATION } from '../../../constants'
import Input from '../input'
import { OptionSwitcher } from '../option-switcher/option-switcher'
import classnames from 'classnames'
import { UserPermissions } from '../../../../../services/permissions'

export const NetworkDeviceFilters = ({
    filters,
    locale,
    onChange,
    className,
    location
}) => {
    const classes = useStyles()

    const onSearch = value => {
        onChange({ type: 'search', value })
    }

    let isAssignedSwitcherVisible = false
    if (location) {
        isAssignedSwitcherVisible =
            (UserPermissions.isAllOriginalGranted() &&
                UserPermissions.isOriginalEntity(location?.customer_id)) ||
            UserPermissions.isTraplinkedAdmin()
    } else {
        isAssignedSwitcherVisible = UserPermissions.isAllOriginalGranted()
    }

    return (
        <Box className={classnames([classes.filtersWrapper, className])}>
            {isAssignedSwitcherVisible && (
                <OptionSwitcher
                    large
                    className={classes.switcher}
                    options={{
                        [REPRESENTATION.all]: locale.devices.allDevices,
                        [REPRESENTATION.assigned]: locale.devices.assigned
                    }}
                    selected={
                        filters.is_assigned
                            ? REPRESENTATION.assigned
                            : REPRESENTATION.all
                    }
                    onChange={value =>
                        onChange({
                            type: 'is_assigned',
                            value: value === REPRESENTATION.assigned
                        })
                    }
                />
            )}

            <Input
                value={filters.search}
                className={classes.searchInput}
                label={locale.common.search}
                type="text"
                setValue={onSearch}
                debounce={600}
                endIcon={() =>
                    filters.search ? (
                        <IconButton
                            size="small"
                            onClick={() => onSearch('')}
                            classes={{ root: classes.saerchClearIcon }}>
                            <Clear />
                        </IconButton>
                    ) : null
                }
            />
        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    switcher: {
        marginRight: 12
        // marginBottom: 16
    },
    input: {
        fontSize: 14,
        // height: '32px',
        // width: 150,
        borderRadius: theme.borderRadius
        // marginRight: 32
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap'
    },
    searchInput: {
        width: 170
        // marginBottom: 16
    },
    saerchClearIcon: {
        padding: 0,
        position: 'absolute',
        right: 14
    }
}))
